// extracted by mini-css-extract-plugin
export default {"inputGroup":"AddressInputFields_inputGroup__4K1Hz","fullWidth":"AddressInputFields_fullWidth__QRAdQ","halfWidth":"AddressInputFields_halfWidth__TQ7eN"};